var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlowOneLinkManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 244,
    viewBox: "0 0 244 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 243.149,
    height: 243.149,
    rx: 20,
    fill: "#F57F4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2808 100.525C91.3548 100.525 90.4668 100.893 89.8121 101.548C89.1574 102.203 88.7896 103.091 88.7896 104.017V150.718C88.7896 151.644 89.1574 152.532 89.8121 153.187C90.4668 153.842 91.3548 154.21 92.2808 154.21H138.983C139.908 154.21 140.796 153.842 141.451 153.187C142.106 152.532 142.474 151.644 142.474 150.718V125.245C142.474 122.483 144.712 120.245 147.474 120.245C150.235 120.245 152.474 122.483 152.474 125.245V150.718C152.474 154.296 151.052 157.728 148.522 160.258C145.992 162.788 142.561 164.21 138.983 164.21H92.2808C88.7027 164.21 85.2711 162.788 82.741 160.258C80.2109 157.728 78.7896 154.296 78.7896 150.718V104.017C78.7896 100.439 80.2109 97.007 82.741 94.4769C85.2711 91.9468 88.7027 90.5254 92.2808 90.5254H117.754C120.516 90.5254 122.754 92.764 122.754 95.5254C122.754 98.2868 120.516 100.525 117.754 100.525H92.2808Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.737 82.7891C129.737 80.0276 131.975 77.7891 134.737 77.7891H160.211C162.972 77.7891 165.211 80.0276 165.211 82.7891V108.263C165.211 111.024 162.972 113.263 160.211 113.263C157.449 113.263 155.211 111.024 155.211 108.263V87.7891H134.737C131.975 87.7891 129.737 85.5505 129.737 82.7891Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.746 79.2535C165.699 81.2062 165.699 84.372 163.746 86.3246L117.044 133.026C115.092 134.979 111.926 134.979 109.973 133.026C108.021 131.074 108.021 127.908 109.973 125.955L156.675 79.2535C158.628 77.3009 161.793 77.3009 163.746 79.2535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowOneLinkManager);
export default __webpack_public_path__ + "static/media/icon-flow-one-link-manager.8130f7453dc6fb4f991ad5fe865b1f10.svg";
export { ForwardRef as ReactComponent };